import { render, staticRenderFns } from "./ColSettingTable.vue?vue&type=template&id=f0ef27f8&scoped=true"
import script from "./ColSettingTable.vue?vue&type=script&lang=js"
export * from "./ColSettingTable.vue?vue&type=script&lang=js"
import style0 from "./ColSettingTable.vue?vue&type=style&index=0&id=f0ef27f8&prod&lang=css"
import style1 from "./ColSettingTable.vue?vue&type=style&index=1&id=f0ef27f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0ef27f8",
  null
  
)

export default component.exports